const MAX_FRACTION_DIGITS = 20;
const DECIMAL_VALUE_PATTERN = /^([+-]?)(?:(\d+)(?:\.(\d*))?|\.(\d+))$/;

const clampFractionDigits = (value) => {
  const digits = Number(value);
  if (!Number.isFinite(digits)) return 2;
  return Math.min(MAX_FRACTION_DIGITS, Math.max(0, Math.trunc(digits)));
};

const addGroupSeparators = (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const incrementDigitString = (digits) => {
  const result = digits.split("");

  for (let i = result.length - 1; i >= 0; i -= 1) {
    if (result[i] !== "9") {
      result[i] = String(Number(result[i]) + 1);
      return result.join("");
    }
    result[i] = "0";
  }

  return `1${result.join("")}`;
};

export const formatPoolFactor = (value, maximumFractionDigits = 20) => {
  if (value === undefined || value === null || value === "") return "---";

  const rawValue = String(value).trim().replace(/,/g, "");
  if (!rawValue) return "---";

  const fractionDigits = clampFractionDigits(maximumFractionDigits);
  const decimalMatch = rawValue.match(DECIMAL_VALUE_PATTERN);

  if (decimalMatch) {
    const sign = decimalMatch[1] === "-" ? "-" : "";
    let integerPart = (decimalMatch[2] || "0").replace(/^0+(?=\d)/, "");
    const fractionPart = decimalMatch[3] ?? decimalMatch[4] ?? "";
    const keptFraction = fractionPart.slice(0, fractionDigits);
    const shouldRoundUp =
      fractionPart.length > fractionDigits && Number(fractionPart[fractionDigits]) >= 5;

    let digits = `${integerPart}${keptFraction.padEnd(fractionDigits, "0")}`;
    let integerLength = integerPart.length;

    if (shouldRoundUp) {
      const originalLength = digits.length;
      digits = incrementDigitString(digits);
      if (digits.length > originalLength) integerLength += 1;
    }

    integerPart = digits.slice(0, integerLength) || "0";
    const roundedFraction = fractionDigits > 0
      ? digits.slice(integerLength).padEnd(fractionDigits, "0").replace(/0+$/, "")
      : "";

    const isZeroValue = /^0+$/.test(integerPart) && roundedFraction === "";
    const displaySign = isZeroValue ? "" : sign;
    const groupedInteger = addGroupSeparators(integerPart.replace(/^0+(?=\d)/, ""));

    return roundedFraction
      ? `${displaySign}${groupedInteger}.${roundedFraction}`
      : `${displaySign}${groupedInteger}`;
  }

  const numericValue = Number(rawValue);
  if (!Number.isFinite(numericValue)) return "---";

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  });
};
